// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FORM SUCCESS SCROLL


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});


//
// =FORM
// --------------------------------------------------

const forms = document.querySelectorAll('.jwsdw-raffleForm');

Array.from(forms).forEach((form) => {
  if (form) {
    // imageUpload: ADD filename to span
    const fileNameSpan = form.querySelector('.jws-fileInputName');
    const imageUpload = form.querySelector('#imageUpload');

    for( i in imageUpload ) {
      imageUpload[i].onchange = function() {
        console.log(i);
        fileNameSpan[0].innerHTML = this.files[0].name;
      }
    }

    // form sent event
    form.addEventListener('raffle:submitted', (e) => {
      // let response = e.detail;
      // if (response.isNewUser) {
      //     //do smth for newly registered users
      // } else {
      //     //do smth for already registered users
      // }
      form.classList.add('jwsdw-lottery-is-successful');
    });
  }
});


//
// =FORM SUCCESS SCROLL
// --------------------------------------------------

var form = document.getElementById('section_participate');

if (form) {
  // console.log('form is here');
  var observerForm = new MutationObserver(function (event) {
    // console.log(event);
    $("html, body").animate({
        scrollTop: $('#section_participate').offset().top - 64,
      }, 500);
    // console.log('form after animate');
  });

  observerForm.observe(form, {
    attributes: true,
    attributeFilter: ['class', 'data-state'],
    childList: false,
    characterData: false
  });
}
